import React, { FunctionComponent, useContext, useState } from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { SecondaryButton } from '../../atoms/secondaryButton/SecondaryButton'
import { AppContext } from '../../context'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { CoverageMessagingModal, CoverageMessagingModalProps } from '../coverageMessagingModal/CoverageMessagingModal'

export interface CoverageMessagingButtonProps
  extends Omit<CoverageMessagingModalProps, 'setIsModalOpen' | 'isModalOpen'> {
  isCostMessagingEnabled: boolean
}

export const CoverageMessagingButton: FunctionComponent<CoverageMessagingButtonProps> = ({
  coverageModalContents = [],
  coverageModalTitleText,
  costMessagingModalCoverageInfo = undefined,
  isCostMessagingEnabled,
  trackCoverageModalPress,
  customerName,
  numSessions,
  numberOfSessionByProgram,
  displayVisitsPerIssuePerYear,
  displayVisitsPerIssuePerYearByProgram,
  subheaderText,
  goToSearchForCare,
}) => {
  const { formatMessage } = useIntl()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { breakpoints } = useTheme() as ThemeType
  const { isHideCostAndSessionLimitEnabled } = useContext(AppContext)
  const isMobileSized = breakpoints.isMobileSized
  const showCoverageModal =
    !isHideCostAndSessionLimitEnabled &&
    isCostMessagingEnabled &&
    costMessagingModalCoverageInfo &&
    costMessagingModalCoverageInfo?.customerCoverageType &&
    coverageModalContents &&
    coverageModalContents.length > 0

  if (!showCoverageModal) {
    return <></>
  }

  return (
    <>
      <SecondaryButton
        text={formatMessage({
          defaultMessage: 'Understand your coverage',
          description: "Link to open a modal which explains the member's care coverage",
        })}
        onPress={() => {
          trackCoverageModalPress(true)
          setIsModalOpen(true)
        }}
        testID={tID('CoverageMessagingButton')}
        customTextSize={!isMobileSized ? BodyTextSize.LARGE : undefined}
        style={{ ...(!isMobileSized ? { height: 60 } : {}), width: 290 }}
      />
      <CoverageMessagingModal
        isModalOpen={isModalOpen}
        setIsModalOpen={(isOpen) => setIsModalOpen(isOpen)}
        coverageModalTitleText={coverageModalTitleText}
        coverageModalContents={coverageModalContents}
        costMessagingModalCoverageInfo={costMessagingModalCoverageInfo}
        trackCoverageModalPress={trackCoverageModalPress}
        customerName={customerName}
        numSessions={numSessions}
        numberOfSessionByProgram={numberOfSessionByProgram}
        displayVisitsPerIssuePerYear={displayVisitsPerIssuePerYear}
        displayVisitsPerIssuePerYearByProgram={displayVisitsPerIssuePerYearByProgram}
        subheaderText={subheaderText}
        goToSearchForCare={goToSearchForCare}
      />
    </>
  )
}
